export const frontmatter = {
  category: 'guia',
  title: 'Qué llevar a Ilha do Mel: Lista completa 2026',
  excerpt: 'No olvides nada en tu viaje a Ilha do Mel. Consulta la lista completa con los artículos esenciales, lo que no necesitas llevar y consejos de los lugareños para un viaje ligero y sin preocupaciones.',
  publishedAt: '2026-04-23',
  author: 'Guia Ilha do Mel',
  tags: ['checklist', 'dicas-praticas', 'o-que-levar'],
  coverImage: '/images/hero-bg.jpg',
  readingTime: '5 min',
};

Qué llevar a Ilha do Mel: Lista completa

Ilha do Mel es un destino sin coches, cajeros automáticos y con infraestructura limitada. **Viajar ligero y bien preparado** marca la diferencia entre un viaje tranquilo y una serie de contratiempos.

Esta lista de verificación se elaboró con consejos de residentes y personas que han estado allí docenas de veces.

---

Antes de salir de casa

Documentos

- [ ] RG o CNH (documento con foto)

- [ ] Comprobante de reservación de la casa de huéspedes
- [ ] Efectivo (se acepta PIX, pero la señal es inestable)

- [ ] Tarjeta de débito/crédito (para emergencias en Paranaguá/Pontal)

**Consejo local:** Lleva al menos R$300-500 en efectivo para una estancia de 2 a 3 días. Casi ningún quiosco acepta tarjetas.

---

Ropa y calzado

| Artículo | Cantidad | Nota |

| ---------------------- | ---------- | ----------------------------------------------- |

| Bikini/bañador | 2-3 | No se seca rápido con la humedad de la isla |

| Toalla de playa | 1 | Ligera y de microfibra, ocupa menos espacio |

| Camisetas ligeras | 3-4 | De algodón o tejido técnico |

| Pantalones cortos | 2-3 | Para senderismo y playa |

| Pantalones ligeros | 1 | Para senderismo y noches frescas |

| Sudadera/chaqueta ligera | 1 | Viento nocturno, incluso en verano |

| Chanclas | 1 par | Para uso diario en la arena |

| Botas de senderismo | 1 par | **Imprescindibles** para senderismo (no usar sandalias) |

| Sombrero/gorra | 1 | Protección solar imprescindible |

| Gafas de sol | 1 | Con protección UV |

---

Higiene y salud

- [ ] Protector solar **SPF 50+** (el sol se refleja en la arena y quema más)

- [ ] Repelente de insectos
- [ ] Crema hidratante para después del sol
- [ ] Champú y jabón (es posible que la casa de huéspedes no los proporcione)

- [ ] Cepillo y pasta de dientes

- [ ] Medicamentos para el mareo (las travesías en barco pueden ser agitadas)

- [ ] Analgésico (dipirona/paracetamol)

- [ ] Vendas y antiséptico

- [ ] Preservativos (no hay farmacias en la isla)

**Atención:** No hay farmacia en Ilha do Mel. Traiga todos los medicamentos que pueda necesitar.

---

Electrónica

- [ ] Cargador de celular + batería externa

- [ ] Auriculares (la isla es tranquila; aprovéchalo)

- [ ] Cámara (opcional; el paisaje lo amerita)

- [ ] Linterna o celular con linterna (las calles no están iluminadas por la noche)

- [ ] Adaptador de corriente (consulta con la casa de huéspedes)

---

A la playa

- [ ] Máscara de snorkel (opcional; el agua es cristalina)

- [ ] Bolsa térmica pequeña (para agua y refrigerios)

- [ ] Botella de agua reutilizable

- [ ] Bolsa reutilizable (no se permiten bolsas de plástico en la isla)

- [ ] Libro/lector electrónico (la playa invita a desconectar)

---

Qué NO traer

| Artículo | ¿Por qué dejarlo en casa? |

| --------------------- | ---------------------------------------------------- |

| Maleta con ruedas | Calles arenosas y rocosas: la llevarás a cuestas |

| Secador de pelo | La electricidad es un bien preciado y pocas casas de huéspedes la tienen |

| Utensilios de cocina | No hay cocina compartida: come en los restaurantes |

| Ropa de lujo | Entorno rústico y arena por todas partes |

| Vales de comida/VR | No se aceptan en ningún sitio |

---

Mochila o maleta: ¿Cuál elegir?

**Una mochila es la mejor opción.** Sin excepción.

- No hay coches en la isla; tendrás que cargar con todo a la espalda.

- Los caminos de arena, piedra y tierra hacen que las maletas con ruedas sean inútiles.

- Para cruzar en barco, tendrás que llevar tus pertenencias hasta la casa de huéspedes.

**Regla de oro:** si no puedes cargarlo tú solo durante 1 km de sendero, no lo lleves.

---

Lista de verificación rápida para 2 días

```
☐ RG + reserva da pousada
☐ R$ 300-500 em espécie
☐ 2 biquínis + 3 camisetas + 2 shorts
☐ Tênis de trilha + chinelo
☐ Protetor solar FPS 50 + repelente
☐ Power bank + carregador
☐ Remédios básicos
☐ Mochila (não mala!)
```

---

Último consejo: viaja ligero.

Ilha do Mel recompensa a quienes viajan ligeros. Menos equipaje significa más libertad para explorar senderos, subir al faro y caminar entre pueblos sin cargar con peso a la espalda.

¿Quieres saber cómo llegar a Ilha do Mel, dónde alojarte y cuánto cuesta? Nuestra guía completa de Ilha do Mel incluye itinerarios prediseñados, presupuestos adaptados a cada perfil y consejos de los lugareños para ayudarte a planificar el viaje perfecto.